// extracted by mini-css-extract-plugin
module.exports = {"containerSp":"Support_containerSp__2gl8_","title":"Support_title__2xAyF"};